import { actionCreator, ActionReturnType, Loading, loadingFailed, loadingFinished, loadingIsLoading, loadingNotStarted } from "@itk/typescript-utils";
import { Model_ProductTypeAttributesGet, Model_SystemProductConfigurationItemsBulkAttributePut } from "src/backend/openapi/v1";

export enum Action {
  GetProductTypeAttributesRequest = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:GETPRODUCTTYPEATTRIBUTESREQUEST",
  RefreshProductTypeAttributesRequest = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:REFRESHPRODUCTTYPEATTRIBUTESREQUEST",
  GetProductTypeAttributesSuccess = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:GETPRODUCTTYPEATTRIBUTESSUCCESS",
  GetProductTypeAttributesFail = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:GETPRODUCTTYPEATTRIBUTESFAIL",

  SetSelectedProductTypeId = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:SETSELECTEDPRODUCTTYPEID",

  UpdateAttributeRequest = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:UPDATEATTRIBUTEREQUEST",

  Clear = "@@ITK:SRC:PAGES:BULK-CONFIGURE-PRODUCTS:BULK-CONFIGURE-PRODUCTS-STORE.TS:ACTION:CLEAR"
}

// The selection the panel is editing. The item ids are what let the server decide which values every
// selected product already shares, so they travel with the product type ids rather than separately.
export type TProductTypeAttributesRequest = {
  productTypeIds: string[];
  systemProductConfigurationItemIds: string[];
};

type TBulkConfigureProductsState = {
  productTypeAttributesState: Loading<Model_ProductTypeAttributesGet[]>;
  selectedProductTypeId?: string;
  // Kept so a write can re-read the same selection without the page having to drive it again
  attributesRequest?: TProductTypeAttributesRequest;
};

const initialState: TBulkConfigureProductsState = {
  productTypeAttributesState: loadingNotStarted,
  selectedProductTypeId: undefined,
  attributesRequest: undefined
};

export const bulkConfigureProductsActions = {
  getProductTypeAttributesRequest: (request: TProductTypeAttributesRequest) => actionCreator(Action.GetProductTypeAttributesRequest, { request }),
  // Same fetch, but the panel keeps showing what it has: a write must not flash the skeletons back
  refreshProductTypeAttributesRequest: () => actionCreator(Action.RefreshProductTypeAttributesRequest),
  getProductTypeAttributesSuccess: (data: Model_ProductTypeAttributesGet[]) => actionCreator(Action.GetProductTypeAttributesSuccess, { data }),
  getProductTypeAttributesFail: () => actionCreator(Action.GetProductTypeAttributesFail),

  setSelectedProductTypeId: (productTypeId?: string) => actionCreator(Action.SetSelectedProductTypeId, { productTypeId }),

  updateAttributeRequest: (data: Required<Model_SystemProductConfigurationItemsBulkAttributePut>, shouldDebounce: boolean, onError?: () => void) =>
    actionCreator(Action.UpdateAttributeRequest, { data, shouldDebounce, onError }),

  clear: () => actionCreator(Action.Clear)
};

export const bulkConfigureProductsReducer = (state = initialState, action: ActionReturnType<typeof bulkConfigureProductsActions>): TBulkConfigureProductsState => {
  switch (action.type) {
    case Action.GetProductTypeAttributesRequest:
      return { ...state, productTypeAttributesState: loadingIsLoading, attributesRequest: action.payload.request };
    case Action.GetProductTypeAttributesSuccess:
      return { ...state, productTypeAttributesState: loadingFinished(action.payload.data) };
    case Action.GetProductTypeAttributesFail:
      return { ...state, productTypeAttributesState: loadingFailed };

    case Action.SetSelectedProductTypeId:
      return { ...state, selectedProductTypeId: action.payload.productTypeId };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
